/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftGrouping } from './NftGrouping';
import {
    NftGroupingFromJSON,
    NftGroupingFromJSONTyped,
    NftGroupingToJSON,
    NftGroupingToJSONTyped,
} from './NftGrouping';
import type { NftTracker } from './NftTracker';
import {
    NftTrackerFromJSON,
    NftTrackerFromJSONTyped,
    NftTrackerToJSON,
    NftTrackerToJSONTyped,
} from './NftTracker';

/**
 * 
 * @export
 * @interface GetNftGroupingResponse
 */
export interface GetNftGroupingResponse {
    /**
     * 
     * @type {NftGrouping}
     * @memberof GetNftGroupingResponse
     */
    nftGrouping: NftGrouping;
    /**
     * 
     * @type {Array<NftTracker>}
     * @memberof GetNftGroupingResponse
     */
    nftTrackers: Array<NftTracker>;
}

/**
 * Check if a given object implements the GetNftGroupingResponse interface.
 */
export function instanceOfGetNftGroupingResponse(value: object): value is GetNftGroupingResponse {
    if (!('nftGrouping' in value) || value['nftGrouping'] === undefined) return false;
    if (!('nftTrackers' in value) || value['nftTrackers'] === undefined) return false;
    return true;
}

export function GetNftGroupingResponseFromJSON(json: any): GetNftGroupingResponse {
    return GetNftGroupingResponseFromJSONTyped(json, false);
}

export function GetNftGroupingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNftGroupingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nftGrouping': NftGroupingFromJSON(json['nftGrouping']),
        'nftTrackers': ((json['nftTrackers'] as Array<any>).map(NftTrackerFromJSON)),
    };
}

export function GetNftGroupingResponseToJSON(json: any): GetNftGroupingResponse {
    return GetNftGroupingResponseToJSONTyped(json, false);
}

export function GetNftGroupingResponseToJSONTyped(value?: GetNftGroupingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nftGrouping': NftGroupingToJSON(value['nftGrouping']),
        'nftTrackers': ((value['nftTrackers'] as Array<any>).map(NftTrackerToJSON)),
    };
}

